// extracted by mini-css-extract-plugin
export default {"BTN":"BTN_BTN__AHrFE"};